import { useState } from "react";
import { UploadCloud, X, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function PhotoUploader({ label, hint, kind, photos, setPhotos, max = 4, lang }) {
  const [busy, setBusy] = useState(false);
  const mine = photos.filter((p) => p.kind === kind);

  const onSelect = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (mine.length + files.length > max) {
      toast.error(lang === "pl" ? `Maksymalnie ${max} zdjęć.` : `Max ${max} photos.`);
      return;
    }
    setBusy(true);
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        const preview = URL.createObjectURL(file);
        setPhotos((prev) => [...prev, { id: data.id, filename: data.filename, kind, preview }]);
      } catch (err) {
        toast.error(lang === "pl" ? "Nie udało się przesłać zdjęcia." : "Upload failed.");
      }
    }
    setBusy(false);
  };

  const remove = (id) => setPhotos((prev) => prev.filter((p) => p.id !== id));

  return (
    <div>
      <span className="text-xs uppercase tracking-[0.15em] text-[#64748B] font-medium">{label}</span>
      {hint && <p className="text-xs text-[#94A3B8] mt-1">{hint}</p>}
      <div className="mt-3 flex flex-wrap gap-3">
        {mine.map((p) => (
          <div key={p.id} className="relative h-24 w-24 rounded-2xl overflow-hidden border border-[#E7E0D4]">
            <img src={p.preview} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => remove(p.id)} data-testid="remove-photo" className="absolute top-1 right-1 h-6 w-6 rounded-full bg-[#1A243A]/80 text-white flex items-center justify-center"><X size={13} /></button>
          </div>
        ))}
        {mine.length < max && (
          <label className="h-24 w-24 rounded-2xl border border-dashed border-[#D4AF37]/60 bg-white/60 flex flex-col items-center justify-center cursor-pointer hover:border-[#D4AF37] transition-colors text-[#64748B]" data-testid={`upload-${kind}`}>
            {busy ? <Loader2 className="animate-spin" size={20} /> : <UploadCloud size={20} className="text-[#D4AF37]" />}
            <span className="text-[10px] mt-1 uppercase tracking-wide">{lang === "pl" ? "Dodaj" : "Add"}</span>
            <input type="file" accept="image/*" multiple className="hidden" onChange={onSelect} />
          </label>
        )}
      </div>
    </div>
  );
}
